import { render, staticRenderFns } from "./ZgYsFile.vue?vue&type=template&id=39bf810a&scoped=true&"
import script from "./ZgYsFile.vue?vue&type=script&lang=js&"
export * from "./ZgYsFile.vue?vue&type=script&lang=js&"
import style0 from "./ZgYsFile.vue?vue&type=style&index=0&id=39bf810a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf810a",
  null
  
)

export default component.exports